import { tableHelper } from "@/helpers/table.helper";
import { getBlankCriteria, getBlankRecord } from "./helpers";
import { getBlankNextPreviousInfo } from "@/store/helpers";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      criteria: getBlankCriteria(),
      criteriaInfo: tableHelper.getBlankCriteriaInfo(),
      data: [],
      paging: tableHelper.getDefaultPaging(),
      loading: false,
      loaded: false
    },
    view: {
      data: getBlankRecord(),
      next: getBlankNextPreviousInfo(),
      previous: getBlankNextPreviousInfo(),
      breadcrumbs: [{ text: "..." }],
      exceptionId: null,
      loading: false,
      loaded: false
    },
    week: {
      loading: false,
      loaded: false,
      active: true,
      data: {}
    },
    month: {
      loading: false,
      loaded: false,
      active: false,
      data: {}
    },
    connectivity: {
      loading: false,
      loaded: false,
      data: {}
    },
    throw: {
      processing: false
    }
  };
}

export function getUnloadedState() {
  return {
    listing: {
      loaded: false
    },
    view: {
      loaded: false
    },
    week: {
      loaded: false
    },
    connectivity: {
      loaded: false
    }
  };
}
